const state = () => ({
  isValid: false,
  evaluation: '',
  message: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  evaluation(state) {
    return state.evaluation;
  },
  message(state) {
    return state.message;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateEvaluation(state, payload) {
    state.evaluation = payload;
  },
  updateMessage(state, payload) {
    state.message = payload;
  }
};

const actions = {
  updateEvaluation({ commit }, payload) {
    commit('updateEvaluation', payload);
  },
  updateMessage({ commit }, payload) {
    commit('updateMessage', payload);
  }
};

export const evaluationInfo = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
